/**
 * Tabulator header filter – textový input, ktorý spustí filtrovanie až po stlačení Enter
 * (nie pri každej zmene). Pri vyprázdnení poľa filter zruší bez Enteru.
 *
 * Remote (filterMode: 'remote'): success() → Tabulator ajax reload.
 * Local: success() — rovnaký pattern ako ChecklistHolidayList / RoleList.
 *
 * Použitie: headerFilter: inputOnEnterHeaderFilter + headerFilterLiveFilter: false
 */
export function inputOnEnterHeaderFilter(cell, onRendered, success, cancel, editorParams) {
  const mount = document.createElement('div');
  mount.style.cssText = 'padding:0;width:100%;max-width:100%;min-width:0;box-sizing:border-box;';
  // Tabulator Filter.js assigns headerElement only after this editor returns.
  // Calling getHeaderFilterValue() here logs "Column Filter Error - No header filter set on column".
  // cell.getValue() is the Filter cellWrapper initialValue and is safe during construction.
  const raw = cell?.getValue?.();
  const initial = raw === undefined || raw === null ? '' : String(raw);
  const input = document.createElement('input');
  input.type = 'text';
  input.value = initial;
  input.placeholder = editorParams?.placeholder ?? '';
  input.style.cssText = 'width:100%;padding:4px;box-sizing:border-box;';
  input.setAttribute('data-header-filter-input', '1');

  const applyFilter = () => {
    const v = input.value == null ? '' : String(input.value).trim();
    success(v);
  };

  input.addEventListener('input', () => {
    if ((input.value || '').trim() === '') {
      success('');
    }
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(applyFilter, 0);
    }
  });

  mount.appendChild(input);
  onRendered(() => {});

  return mount;
}
